/* MLFL-115: Mobile-only controls for TOP special-feature cards. */
(() => {
  const SECTION_SELECTOR =
    '[data-section-type="columns-with-image"][data-section-id*="section_columns_axqC7L"]';
  const mobile = window.matchMedia('(max-width: 767px)');

  function init(context = document) {
    const sections = [];
    if (context.matches?.(SECTION_SELECTOR)) sections.push(context);
    sections.push(...context.querySelectorAll(SECTION_SELECTOR));

    sections.forEach((root) => {
      const slider = root.querySelector('[data-slider]');
      const controls = root.querySelector('[data-mlfl115-controls]');
      if (!slider || !controls || controls.dataset.mlfl115Ready === 'true') return;
      controls.dataset.mlfl115Ready = 'true';

      const previous = controls.querySelector('[data-mlfl115-prev]');
      const next = controls.querySelector('[data-mlfl115-next]');
      if (!previous || !next) return;

      function update() {
        const maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
        const enabled = mobile.matches && maxScroll > 4;

        if (enabled) {
          const wrapper = root.querySelector('.section-columns__wrapper');
          const image = slider.querySelector('.column__item__image-wrapper');
          if (wrapper && image) {
            const wrapperRect = wrapper.getBoundingClientRect();
            const imageRect = image.getBoundingClientRect();
            const arrowY = imageRect.top - wrapperRect.top + imageRect.height / 2;
            controls.style.setProperty('--mlfl115-arrow-y', `${arrowY}px`);
          }
        }

        controls.hidden = !enabled;
        previous.disabled = slider.scrollLeft <= 4;
        next.disabled = slider.scrollLeft >= maxScroll - 4;
      }

      function scrollStep() {
        const items = slider.querySelectorAll('[data-slider-item]');
        if (!items.length) return 0;
        if (items.length > 1) {
          const distance = items[1].offsetLeft - items[0].offsetLeft;
          if (distance > 0) return distance;
        }
        const styles = window.getComputedStyle(items[0]);
        return items[0].getBoundingClientRect().width +
          (parseFloat(styles.marginRight) || 0);
      }

      previous.addEventListener('click', () => {
        slider.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', () => {
        slider.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
      slider.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      // Update once image dimensions have settled.
      root.querySelectorAll('.column__item__image-wrapper img').forEach((image) => {
        image.addEventListener('load', update, { once: true });
      });
      window.requestAnimationFrame(update);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
